import * as React from 'react';
import classnames from 'classnames';

import './style.scss';

interface IAttachButtonProps {
  id: string;
  onClick: TButtonOnClick;
  multiple?: boolean;
  accept?: string;
  label: string;
}

interface IAttachButtonState {}

export default class AddRelatedDocumentsButton extends React.Component<IAttachButtonProps, IAttachButtonState> {
  static defaultProps = {
    onClick: () => null,
    multiple: true,
    accept: '',
  };

  render() {
    const { id, multiple, accept, label, onClick } = this.props;

    return (
      <div>
        <label className={classnames('related-doc-btn')} htmlFor={id}>
          {label}
        </label>
        <input id={id} type="file" accept={accept} onChange={onClick} multiple={multiple} />
      </div>
    );
  }
}
